import { get } from "lodash";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";

const kenwoodItalyBasicMixin = {
  computed: {
    propertyInfo() {
      return globalState.pageModel.context.content_map.property;
    },
    color(){
      if (this.content.category_color) {
        return this.content.category_color;
      } else if (this.decorator && this.decorator.color) {
        return this.decorator.color;
      } else {
        return "orange";
      }
    },
  },
  methods: {
    getTitleStyle: function(partial) {
      let styleClasses = [];
      if(partial.class) {
        styleClasses.push(`title-${partial.class}`);
      }
      if(partial.color) {
        if(partial.color !== true)  {
          styleClasses.push(`text-${partial.color}`);
        } else {
          styleClasses.push(`text-${this.color}`);
        } 
      }
      if(partial.block) {
        styleClasses.push("d-block");
      }
      return styleClasses.join(" ");
    }
  }
};

const kenwoodItalyAuthorizationMixin = {
  computed: {
    relatedContent() {
      return get(this, ["pageMode", "name_to_content", this.content.sealable_content], false);
    },
    sealedContent() {
      return this.relatedContent ? this.relatedContent : this.content;
    },
    authorization() {
      return get(this.pageModel, ["name_to_content_authorization", this.sealedContent.name], false);
    },
    authorized() {
      return get(this, ["authorization", "authorized"], true);
    },
    authType() {
      return get(this, ["authorization", "type"], false);
    },
  },
  methods: {
    mayRedirectOnFreeContent(redirectWhenUnlocked = false) {
      sendFandomAnalyticsEvent("Content Interaction", "Obtain Button Click", this.containerContent.name);
      if (this.authorized || (Fandom.isUserRegistered() && this.authType === "user_contents")) {
        sendFandomAnalyticsEvent("Content Interaction", "Content Obtained", this.containerContent.name);
      } else {
        if (this.authType === "registration" || !Fandom.isUserRegistered()) {
          $("#modal-authentication-required").modal("show");
        } else if (this.authType === "user_group"){
          Fandom.emit("modal-user-group-required", { data: this.sealedContent, redirectWhenUnlocked });
        }
      }
    }
  }
};

const kenwoodItalyRelatedMixin = {
  data() {
    return {
      resultContent: null,
      tag: undefined,
    };
  },
  methods: {
    getRelatedContentsByNames(names, layout = "tile", filtering = []) {
      if (Fandom.exists(names)) {
        const getContentsParams = {
          include_rich_info: true,
          include_children: true,
          include_content_children: true,
          exclude_content_ids: [this.content.id],
          layout_extra_field_name: "$empty",
          layout: layout,
          limit: 3,
          contents_names: names,
          content_filtering: filtering
        };
        Fandom.getContentsByNames(this.successCallback, getContentsParams);
      }
    },
    getRelatedContents(tag, tileLayout = "tile", filtering = []) {
      if (Fandom.exists(tag)) {
        this.tag = tag;
        const getContentsParams = {
          include_rich_info: true,
          include_children: true,
          include_content_children: true,
          exclude_content_ids: [this.content.id],
          layout_extra_field_name: tileLayout,
          layout: tileLayout,
          content_filtering: filtering.concat([this.tag]),
          include_extra_field_content_filtering: true,
          limit: 3
        };
        Fandom.getSearchableContents(this.successCallback, getContentsParams);
      }
    },
    successCallback(data) {
      this.resultContent = data.name_to_content[data.main_content_name];
      this.resultContent.children.forEach((c, index) => {
        const size = index == 0 ? "widecontent" : "";
        Vue.set(globalState.pageModel.name_to_content[c], "isotope_size", size);
        Vue.set(globalState.pageModel.name_to_content[c], "category", null);
      });
      Vue.set(this.resultContent, 'has_more_children', false);
      Vue.set(this.resultContent, 'column_count', 3);
      Vue.nextTick(() => Fandom.emit("dom-items-loaded"));
    }
  }
};

export {
  kenwoodItalyBasicMixin,
  kenwoodItalyRelatedMixin,
  kenwoodItalyAuthorizationMixin
};
